import authReducer from "./auth";
import spinnerReducer from "./spinnerSlice";


const rootReducer ={
  auth:authReducer,
  spinner: spinnerReducer,
}

export default rootReducer;
